// ------------------------------------
// Constants
// ------------------------------------
export const ADDRESS_GET_REQUEST = "ADDRESS_GET_REQUEST";
export const ADDRESS_GET_REQUEST_SUCCESS = "ADDRESS_GET_REQUEST_SUCCESS";
export const ADDRESS_GET_REQUEST_FAILURE = "ADDRESS_GET_REQUEST_FAILURE";
export const ADDRESS_GET_RESET = "ADDRESS_GET_RESET";

// ------------------------------------
// Actions
// ------------------------------------
export function request(id, resolve, reject) {
  return {
    type: ADDRESS_GET_REQUEST,
    id,
    resolve,
    reject,
  };
}

export function requestSuccess(data, id) {
  return {
    type: ADDRESS_GET_REQUEST_SUCCESS,
    data,
    id,
  };
}

export function requestFailure(error, id) {
  return {
    type: ADDRESS_GET_REQUEST_FAILURE,
    error,
    id,
  };
}

export function reset() {
  return {
    type: ADDRESS_GET_RESET,
  };
}
